(function() {
  "use strict";

  angular
    .module("app")
    .factory("AssetsService", ["$http", "$q", AssetsService]);

  function AssetsService($http, $q) {
    var service = {
      getAssets: getAssets
    };

    function getAssets(assetsArray) {
      var deferred = $q.defer();

      $http({
        method: "POST",
        url: "api/AssetMapping/GetAssets",
        data: '{assets: "' + assetsArray + '"}',
        cache: true // this data rarely updates, no need for an instant re-request
      })
        .success(function(data) {
          deferred.resolve(data);
        })
        .error(function(error) {
          deferred.reject();
        });

      return deferred.promise;
    }

    return service;
  }
})();
